import type { EventDto, GlobalMessage, Totals } from '@pietrochip/shared';
import { useRef } from 'react';
import { useReconnectingSocket, type SocketStatus } from './useReconnectingSocket';

/**
 * Canale globale: tiene aggiornati i conteggi delle card nella home.
 *
 * Non trasporta i chip, solo i totali per evento. Serve a una cosa sola ma
 * importante: se un altro banco chiude dei chip, l'avanzamento sulla home si
 * muove da solo, senza che nessuno debba ricaricare la pagina per sapere a che
 * punto è la giornata.
 */
export type GlobalStreamHandlers = {
  onTotals: (eventId: string, totals: Totals) => void;
  onCreated?: (event: EventDto) => void;
  onUpdated?: (event: EventDto) => void;
  onDeleted?: (eventId: string) => void;
};

export function useGlobalStream(handlers: GlobalStreamHandlers): SocketStatus {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  const { status } = useReconnectingSocket('/api/stream', (raw) => {
    const message = raw as GlobalMessage;
    const current = handlersRef.current;

    switch (message.type) {
      case 'event:changed':
        current.onTotals(message.eventId, message.totals);
        break;
      case 'event:created':
        current.onCreated?.(message.event);
        break;
      case 'event:updated':
        current.onUpdated?.(message.event);
        break;
      case 'event:deleted':
        current.onDeleted?.(message.eventId);
        break;
    }
  });

  return status;
}
